import React, { FC, memo, useContext } from 'react'

import { TZDate } from '@date-fns/tz'
import { format, isToday, isTomorrow } from 'date-fns'

import { AppContext } from 'Const'
import { CartFulfillment } from 'Types'
import { isDelivery } from 'Utils/cartFulfillment'

interface Props {
  fulfillment: CartFulfillment
  isASAP: boolean
}

const DELIVERY_INTERVAL_IN_MSECS = 30 * 60 * 1000

const FulfillmentDateTime: FC<Props> = ({ fulfillment, isASAP }) => {
  const {
    currentLocation: { timezone },
  } = useContext(AppContext)
  const formatDate = (date: Date, formatStr: string) => format(new TZDate(date, timezone), formatStr)
  const formatFulfillmentAt = (formatStr: string) => formatDate(fulfillmentZonedDate, formatStr)

  const fulfillmentDate = new TZDate(fulfillment.currentFulfillmentAt!, timezone)
  const fulfillmentZonedDate = new TZDate(fulfillmentDate, timezone)
  const dayStr = isToday(fulfillmentZonedDate)
    ? `Today (${formatFulfillmentAt('MMM d')})`
    : isTomorrow(fulfillmentZonedDate)
      ? `Tomorrow (${formatFulfillmentAt('MMM d')})`
      : formatFulfillmentAt('E, MMM d')

  let timeStr
  if (isDelivery(fulfillment)) {
    const { scheduleSetting } = fulfillment
    if (scheduleSetting.disableTimeSelector && scheduleSetting.fulfillmentOperatingDay) {
      const operatingHours = scheduleSetting.fulfillmentOperatingDay.operatingHours
      const currentOperatingDayOpens = operatingHours[0].opens
      const currentOperatingDayCloses = operatingHours[operatingHours.length - 1].closes

      const currentZonedOperatingDayOpens = minutesSinceMidnightToDate(currentOperatingDayOpens, timezone)
      const currentZonedOperatingDayCloses = minutesSinceMidnightToDate(currentOperatingDayCloses, timezone)
      console.log({
        [currentOperatingDayOpens]: currentZonedOperatingDayOpens,
        [currentOperatingDayCloses]: currentZonedOperatingDayCloses,
      })
      timeStr = `${formatDate(currentZonedOperatingDayOpens, 'h:mm a')} - ${formatDate(
        currentZonedOperatingDayCloses,
        'h:mm a',
      )}`
    } else {
      timeStr = `${formatFulfillmentAt('h:mm a')} - ${formatDate(
        endOfIntervalZonedTime(fulfillmentDate, timezone),
        'h:mm a',
      )}`
    }
  } else {
    timeStr = formatFulfillmentAt('h:mm a')
  }

  return (
    <>
      {dayStr} at {isASAP ? `ASAP (Approximately at ${timeStr})` : timeStr}
    </>
  )
}

// + 30 minutes
function endOfIntervalZonedTime(startOfIntervalAt: Date, timezone: string): Date {
  return new TZDate(new Date(startOfIntervalAt.getTime() + DELIVERY_INTERVAL_IN_MSECS), timezone)
}

function minutesSinceMidnightToDate(minutesSinceMidnight: number, timezone: string): Date {
  const date = new TZDate(0, 0, timezone)
  date.setMinutes(minutesSinceMidnight)
  return date
}

export default memo(FulfillmentDateTime)
